import * as React from "react";
const SvgArrowUp20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 9,
        fill: "black",
        viewBox: "0 0 14 9"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m12 8.414-5-5-5 5L.586 7 7 .586 13.414 7 12 8.414Z",
      clipRule: "evenodd"
    })
  );
export default SvgArrowUp20Px;
